var __TEMP__ = require('./_root.js');var root = __REQUIRE_DEFAULT__(__TEMP__);

/** Built-in value references. */
var Symbol = root.Symbol;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = Symbol;
